<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="single container-max page-content">
                <div v-if="categoryIds.includes(730)">
                    <h1 class="h2 title">
                        <span>
                            {{ currentVariation | itemName }}
                        </span>
                    </h1>

                    <div class="single__item-text" v-html="currentVariation.texts.description">
                    </div>

                    <div class="single__technical-details" v-html="currentVariation.texts.technicalData">
                    </div>

                    <div class="single__navigation">
                        <a href="/">zurück zur Startseite</a>
                        <a href="/magazin/lexikon">zurück zum Lexikon</a>
                    </div>
                </div>
                <div class="row position-relative" v-else>
                    <div class="col-12 col-md-7 mt-5" id="item-container">
                        <slot name="image-carousel"></slot>
                    </div>

                    <div class="col-12 col-md-5 mt-md-5 single-rightside">
                        <div v-stick-in-parent>
                            <!-- START SINGLEITEM_DETAILS -->
                            <div class="producertag h6 producer text-muted"
                                v-if="currentVariation.filter.hasManufacturer">
                                {{ currentVariation.item.manufacturer.externalName }}
                            </div>

                            <h1 class="h2 title" data-testing="item-name">
                                <span>
                                    {{ currentVariation | itemName }}
                                </span>
                            </h1>

                            <slot name="tag-list"></slot>

                            <div class="single-description"
                                v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''"
                                v-html="currentVariation.texts.shortDescription"></div>

                            <hr>

                            <div class="mb-5">
                                <span class="articlenumber small text-muted">
                                    <b>{{ $translate("Ceres::Template.singleItemId") }} </b>
                                    <span>{{ currentVariation.item.id }}</span>
                                </span>
                            </div>

                            <!-- Variation -->
                            <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                                <variation-select></variation-select>
                            </div>
                            <!-- /Variation -->

                            <!-- Item Bundle -->
                            <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"
                                :bundle-type="currentVariation.variation.bundleType"
                                :bundle-components="currentVariation.bundleComponents"></item-bundle>
                            <!-- /Item Bundle -->

                            <slot name="before-price"></slot>

                            <div class="row"
                                v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                                <order-property-list></order-property-list>
                            </div>
                            <template v-if="showPriceAfterLogin && !isLoggedIn">
                                <p class="hidden-price-hint">Preise sichtbar nach Anmeldung</p>
                            </template>
                            <template v-else>
                                <graduated-prices></graduated-prices>

                                <item-price :show-cross-price="isRecommendedPriceActive"></item-price>
                            </template>

                            <slot name="after-price"></slot>

                            <!--                            <item-availability></item-availability>-->

                            <div class="row my-3">
                                <div class="w-100">
                                    <slot name="before-add-to-basket"></slot>
                                </div>

                                <div class="w-100">
                                    <!--                                TODO: Login-Check: nur b2b kundenklasse darf kaufen, ids aus config und hier prüfen + if not logged in-->
                                    <template v-if="!isLoggedIn">
                                        <div class="single__not-logged-in col-12">
                                            <a class="btn btn-primary single__login-btn" data-toggle="modal"
                                                href="#login" @click="createLoginModal()">Login</a>
                                            <div class="single__login-info" data-toggle="modal"
                                                data-target="#infoModal">
                                                <div class="single__login-info--icon">
                                                    <img :src="pluginPathTheme + '/images/infomodal.svg'" width="80%">
                                                </div>
                                                <div class="single__login-info--text">
                                                    Verkauf nur an gewerbliche Kunden.
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <template v-if="isB2B">
                                            <div v-if="currentVariation.item.itemType === 'set'"
                                                class="alert alert-info w-100">
                                                {{ $translate("Ceres::Template.singleItemSetInfo") }}
                                            </div>
                                            <div v-else class="col-12 ">
                                                <add-to-basket :variation-id="currentVariation.variation.id"
                                                    :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                                    :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                                    :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                                    :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                                    :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                                    :order-properties="currentVariation.properties.filter(function (prop) { return prop.property.isOderProperty })"
                                                    :has-order-properties="currentVariation.hasOrderProperties"
                                                    :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                                                    :use-large-scale="false" :show-quantity="true"
                                                    :item-url="currentVariation | itemURL"
                                                    :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                                    :has-price="currentVariation | hasItemDefaultPrice">
                                                </add-to-basket>
                                            </div>
                                        </template>
                                        <div class="col-12" v-else>
                                            <div class="single__login-info" data-toggle="modal"
                                                data-target="#infoModal">
                                                <div class="single__login-info--icon">
                                                    <img :src="pluginPathTheme + '/images/infomodal.svg'" width="80%">
                                                </div>
                                                <div class="single__login-info--text">Verkauf nur an gewerbliche
                                                    Kunden.
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>

                                <div class="w-100">
                                    <slot name="after-add-to-basket"></slot>
                                </div>
                            </div>

                            <div v-if="isWishListEnabled" class="row">
                                <div class="col-12">
                                    <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                </div>
                            </div>
                            <!-- ./ITEM DETAIL -->

                            <slot name="additional-content-after-add-to-basket"></slot>

                            <hr>

                            <!--                            <span class="vat small text-muted">-->
                            <!--                                * <template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template> {{ $translate("Ceres::Template.singleItemExclusive") }}-->
                            <!--                            <a v-if="hasShippingCostsCategoryId" data-toggle="modal" href="#shippingscosts" :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>-->
                            <!--                            <a v-else :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>-->

                            <!--                            </span>-->

                            <div class="w-100" v-if="currentVariation.variationProperties">
                                <div class="single__zusatz-info-wrapper">
                                    <div class="single__zusatz-info">
                                        <template v-for="outerProp in filteredVariationProperties">
                                            <div v-for="prop in outerProp.properties" class="single__zusatz-info-object"
                                                v-if="prop.id !== 81">
                                                <template v-if="prop.cast !== 'file' && prop.cast !== 'multiSelection'">
                                                    <strong v-if="prop.id === 20">Zusatzinfo zum Produkt</strong>
                                                    <strong v-else-if="prop.names">{{ prop.names.name }}</strong>
                                                    <span v-if="prop.values" v-html="prop.values.value"></span>
                                                </template>

                                                <template v-else-if="prop.cast === 'multiSelection'">
                                                    <strong v-if="prop.names">{{ prop.names.name }}</strong>
                                                    <ul>
                                                        <li v-for="val in prop.values" v-if="val" v-html="val.value">
                                                        </li>
                                                    </ul>
                                                </template>
                                                <a v-else
                                                    :href="'https://cdn02.plentymarkets.com/20a5y485cyym/propertyItems/' + prop.values.value"
                                                    target="_blank"><strong v-if="prop.names">{{ prop.names.name
                                                        }}</strong></a>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>

                            <div class="w-100" v-if="multiSelectProperties.length > 0">
                                <div class="single__zusatz-info-wrapper properties__multiselect mb-3">
                                    <div class="single__zusatz-info">
                                        <div v-for="prop in multiSelectProperties" :key="prop.id"
                                            class="single__zusatz-info-object">
                                            <strong v-if="prop.names" class="properties__property-name">{{
                                                prop.names.name }}</strong>
                                            <div v-for="(value, index) in propertyValues(prop)" :key="index"
                                                class="properties__property-value">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                    viewBox="0 0 32 32" fill="none">
                                                    <path fill="#434D4C" fill-rule="evenodd"
                                                        d="M3.2 16a12.8 12.8 0 1 1 25.6 0 12.8 12.8 0 0 1-25.6 0ZM5.943 16a10.057 10.057 0 1 1 20.114 0 10.057 10.057 0 0 1-20.114 0Z" />
                                                    <path fill="#434D4C" fill-rule="evenodd"
                                                        d="M16 9a1.371 1.371 0 0 1 1.371 1.371v7.258a1.371 1.371 0 0 1-2.742 0V10.371A1.371 1.371 0 0 1 16 9ZM14.629 21a1.371 1.371 0 1 1 2.742 0 1.371 1.371 0 0 1-2.742 0Z" />
                                                </svg>
                                                <span v-html="value"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <slot name="additional-content-after-vat"></slot>
                            <!-- END SINGLEITEM_DETAILS -->
                        </div>
                    </div>

                    <div class="col-12 col-md-7">
                        <!-- ITEM DESCRIPTION -->
                        <div class="my-5">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item" v-if="isDescriptionTabActive">
                                    <a class="nav-link active" data-toggle="tab"
                                        :href="'#details-' + currentVariation.variation.id" role="tab">{{
                                            $translate("Ceres::Template.singleItemDescription") }}</a>
                                </li>

                                <!-- <li class="nav-item" v-if="isTechnicalDataTabActive">
                                    <a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }"
                                        class="nav-link" data-toggle="tab"
                                        :href="'#data-' + currentVariation.variation.id" role="tab">{{
                                            $translate("Ceres::Template.singleItemTechnicalData") }}</a>
                                </li> -->

                                <li class="nav-item hidden">
                                    <a :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }"
                                        class="nav-link" data-toggle="tab" href="#assessments-details" role="tab">{{
                                            $translate("Ceres::Template.singleItemMoreDetails") }}</a>
                                </li>

                                <!-- <li class="nav-item" v-if="showDatasheets">
                                    <a class="nav-link" data-toggle="tab" href="#datasheets-details"
                                        role="tab">Datenblätter</a>
                                </li> -->

                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" href="#shipping-details"
                                        role="tab">Lieferung</a>
                                </li>

                                <!-- <li class="nav-item" v-if="isEuResponsibleTabShown">
                                    <a class="nav-link" data-toggle="tab" href="#eu-responsible" role="tab">{{
                                        $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</a>
                                </li> -->

                                <!-- <li class="nav-item" v-if="isManufacturerTabShown">
                                    <a class="nav-link" data-toggle="tab" href="#manufacturer" role="tab">{{
                                        $translate("Ceres::Template.singleItemManufacturer") }}</a>
                                </li> -->

                                <slot name="add-detail-tabs"></slot>
                            </ul>

                            <div class="tab-content overflow-hidden">
                                <div class="tab-pane active overflow-auto"
                                    :id="'details-' + currentVariation.variation.id" role="tabpanel"
                                    v-if="isDescriptionTabActive">
                                    <div class="my-4" v-html="currentVariation.texts.description">
                                    </div>

                                    <hr class="desc-line">

                                    <slot name="properties"></slot>

                                    <hr class="desc-line">

                                    <div class="my-4" v-html="currentVariation.texts.technicalData">
                                    </div>
                                </div>

                                <!-- <div :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }"
                                    class="tab-pane overflow-auto" :id="'data-' + currentVariation.variation.id"
                                    role="tabpanel" v-if="isTechnicalDataTabActive">
                                    <div class="my-4" v-html="currentVariation.texts.technicalData">
                                    </div>
                                </div> -->

                                <div :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }"
                                    class="tab-pane overflow-auto" id="assessments-details" role="tabpanel">
                                    <div class="my-4">
                                        <table class="table table-striped table-hover table-sm">
                                            <tbody>
                                                <tr v-if="itemConfig.includes('item.id') || itemConfig.includes('all')">
                                                    <td>{{ $translate("Ceres::Template.singleItemId") }}</td>
                                                    <td>{{ currentVariation.item.id }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.item.condition && currentVariation.item.condition.names.name !== '' && (itemConfig.includes('item.condition') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemCondition") }}</td>
                                                    <td>{{ currentVariation.item.condition.names.name }}</td>
                                                </tr>

                                                <tr
                                                    v-if="itemConfig.includes('item.age_rating') || itemConfig.includes('all')">
                                                    <td>{{ $translate("Ceres::Template.singleItemAge") }}</td>
                                                    <td>{{ currentVariation.item.ageRestriction | ageRestriction }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.externalId !== '' && (itemConfig.includes('item.external_id') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemExternalVariationId")
                                                        }}
                                                    </td>
                                                    <td>{{ currentVariation.variation.externalId }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.model !== '' && (itemConfig.includes('item.variation_model') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemModel") }}</td>
                                                    <td>{{ currentVariation.variation.model }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.filter.hasManufacturer && currentVariation.item.manufacturer.externalName !== '' && (itemConfig.includes('item.manufacturer') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemManufacturer") }}</td>
                                                    <td>{{ currentVariation.item.manufacturer.externalName }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.item.producingCountry && currentVariation.item.producingCountry.names.name !== '' && (itemConfig.includes('item.producerCountry') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemManufacturingCountry")
                                                        }}
                                                    </td>
                                                    <td>{{ currentVariation.item.producingCountry.names.name }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.unit && (itemConfig.includes('item.variationBase_content') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemContent") }}</td>
                                                    <td>{{ currentVariation.unit.content }} {{
                                                        currentVariation.unit.names.name }}
                                                    </td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.weightG !== '' && (itemConfig.includes('item.weightG') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemWeight") }}</td>
                                                    <td>{{ currentVariation.variation.weightG }} g</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.weightNetG !== '' && (itemConfig.includes('item.weightNetG') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemNetWeight") }}</td>
                                                    <td>{{ currentVariation.variation.weightNetG }} g</td>
                                                </tr>

                                                <tr
                                                    v-if="itemConfig.includes('item.variation_dimensions') || itemConfig.includes('all')">
                                                    <td>{{ $translate("Ceres::Template.singleItemDimensions") }}</td>
                                                    <td>
                                                        <span>{{ currentVariation.variation.lengthMM }}</span>&times;<!--
                                                --><span>{{ currentVariation.variation.widthMM }}</span>&times;<!--
                                                --><span>{{ currentVariation.variation.heightMM }}</span> mm
                                                    </td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.customsTariffNumber !== '' && (itemConfig.includes('variation.customs_tariff_number') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemCustomsTariffNumber")
                                                        }}
                                                    </td>
                                                    <td>{{ currentVariation.variation.customsTariffNumber }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- <div v-if="itemData.documents[0].data.free.free7 != '' || itemData.documents[0].data.free.free8 != '' || itemData.documents[0].data.free.free11 != ''"
                                    class="tab-pane" id="datasheets-details" role="tabpanel">
                                    <div class="my-4">

                                        <br>
                                        <a v-if="itemData.documents[0].data.free.free7 != ''" class="margin-bottom-05"
                                            :href="itemData.documents[0].data.free.free7" target="_blank">Download
                                            Sicherheitsdatenblatt <span class="fa fa-download"></span></a>
                                        <br>
                                        <a v-if="itemData.documents[0].data.free.free8 != ''" class="margin-bottom-05"
                                            :href="itemData.documents[0].data.free.free8" target="_blank">Download
                                            Produktdatenblatt <span class="fa fa-download"></span></a>
                                        <slot name="my-freitextfeld11"></slot>
                                    </div>
                                </div> -->

                                <div class="tab-pane" id="shipping-details" role="tabpanel">
                                    <div class="my-4">
                                        Lieferzeiten und Lieferkosten können Sie unseren <a
                                            href="/kitaspezial-ch/versand/">Versandbedingungen</a> entnehmen. Bitte
                                        beachten Sie: Für Spielgeräte (Kategorie Spass & Spiel sowie Kategorie Garten &
                                        Aussenbereich) und Möbel (Kategorie Kita-Möbel) gelten besondere
                                        Lieferkonditionen, die in den Versandbedingungen ebenfalls aufgeführt sind.
                                    </div>
                                </div>

                                <!-- <div class="tab-pane overflow-auto" id="eu-responsible" role="tabpanel"
                                    v-if="isEuResponsibleTabShown">
                                    <div class="my-4">
                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                                            <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                                            <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                                            <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                                                {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                                            </span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
                                        </div>
                                    </div>
                                </div> -->

                                <!-- <div class="tab-pane overflow-auto" id="manufacturer" role="tabpanel"
                                    v-if="isManufacturerTabShown">
                                    <div class="my-4">
                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.name }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.legalName }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.street }}</span>
                                            <span>{{ currentVariation.item.manufacturer.houseNo }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.postcode }}</span>
                                            <span>{{ currentVariation.item.manufacturer.town }}</span>
                                            <span v-if="currentVariation.item.manufacturer.countryObject">
                                                {{ currentVariation.item.manufacturer.countryObject.name }}
                                            </span>

                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.email }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.url }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.phoneNumber }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.faxNumber }}</span>
                                        </div>

                                        <div class="p-0">
                                            <span>{{ currentVariation.item.manufacturer.contactUrl }}</span>
                                        </div>
                                    </div>
                                </div> -->

                                <slot name="add-detail-tabs-content"></slot>
                            </div>
                        </div>
                        <!-- ./ITEM DESCRIPTION -->
                    </div>

                </div>

                <div class="bg-gray widget-fw">
                    <div class="container-max single-content">
                        <div class="row">
                            <div class="col-12 p0">
                                <div class="cat-seo__highlights">
                                    <ul class="cat-seo__highlights-list list-unstyled list-inline ">
                                        <li class="cat-seo__highlights-listitem">
                                            {{ $translate('Kitaspezial::Template.singleSeoHighlight1') }}
                                        </li>
                                        <li class="cat-seo__highlights-listitem">
                                            {{ $translate('Kitaspezial::Template.singleSeoHighlight2') }}
                                        </li>
                                        <li class="cat-seo__highlights-listitem">
                                            {{ $translate('Kitaspezial::Template.singleSeoHighlight3') }}
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>

                        <slot name="item-list-container"></slot>
                        <slot name="feedback-container"></slot>

                    </div>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";
import { mapActions } from "vuex";

const _map = require("lodash/map");

// property group "Warnhinweise", rendered in its own box below the other properties
const MULTI_SELECT_PROPERTY_GROUP_ID = 14;

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    provide() {
        return {
            itemId: this.$props.itemId
        }
    },

    computed:
    {
        // all property groups except the multi select group, which is rendered in its own box
        filteredVariationProperties() {
            const groups = [];

            if (isNullOrUndefined(this.currentVariation.variationProperties)) {
                return groups;
            }

            for (const key in this.currentVariation.variationProperties) {
                if (Number(this.currentVariation.variationProperties[key].id) !== MULTI_SELECT_PROPERTY_GROUP_ID) {
                    groups.push(this.currentVariation.variationProperties[key]);
                }
            }

            return groups;
        },

        // flat list of the properties of the multi select group ("Warnhinweise")
        multiSelectProperties() {
            const properties = [];

            if (isNullOrUndefined(this.currentVariation.variationProperties)) {
                return properties;
            }

            for (const key in this.currentVariation.variationProperties) {
                const group = this.currentVariation.variationProperties[key];

                if (Number(group.id) === MULTI_SELECT_PROPERTY_GROUP_ID && !isNullOrUndefined(group.properties)) {
                    for (const propertyKey in group.properties) {
                        properties.push(group.properties[propertyKey]);
                    }
                }
            }

            return properties;
        },

        showDatasheets() {

            let show = false;
            let var7 = false;
            let var8 = false;
            let var11 = false;

            if (this.itemData.documents[0].data.free.free7 !== '' && this.itemData.documents[0].data.free.free7 !== '0' && this.itemData.documents[0].data.free.free7 !== 'null') {
                var7 = true;
            }

            if (this.itemData.documents[0].data.free.free8 !== '' && this.itemData.documents[0].data.free.free8 !== '0' && this.itemData.documents[0].data.free.free8 !== 'null') {
                var8 = true;
            }

            if (this.itemData.documents[0].data.free.free11 !== '' && this.itemData.documents[0].data.free.free11 !== '0' && this.itemData.documents[0].data.free.free11 !== 'null') {
                var11 = true;
            }

            if (var7 || var8 || var11) {
                show = true;
            }

            return show; // show

        },
        itemConfig() {
            return App.config.item.itemData;
        },

        isDescriptionTabActive() {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isManufacturerTabShown() {
            return (this.currentVariation.item.manufacturer.url !== "") ||
                (this.currentVariation.item.manufacturer.street !== "") ||
                (this.currentVariation.item.manufacturer.houseNo !== "") ||
                (this.currentVariation.item.manufacturer.postcode !== "") ||
                (this.currentVariation.item.manufacturer.town !== "") ||
                (this.currentVariation.item.manufacturer.countryId !== 0) ||
                (this.currentVariation.item.manufacturer.phoneNumber !== "") ||
                (this.currentVariation.item.manufacturer.faxNumber !== "") ||
                (this.currentVariation.item.manufacturer.email !== "") ||
                (this.currentVariation.item.manufacturer.legalName !== "") ||
                (this.currentVariation.item.manufacturer.contactUrl !== "") ||
                (this.currentVariation.item.manufacturer.name !== "") ||
                (this.currentVariation.item.manufacturer.externalName !== "");
        },

        isEuResponsibleTabShown() {
            return (this.currentVariation.item.manufacturer.responsibleEmail !== "") ||
                (this.currentVariation.item.manufacturer.responsibleHouseNo !== "") ||
                (this.currentVariation.item.manufacturer.responsibleName !== "") ||
                (this.currentVariation.item.manufacturer.responsiblePhoneNo !== "") ||
                (this.currentVariation.item.manufacturer.responsiblePostCode !== "") ||
                (this.currentVariation.item.manufacturer.responsibleStreet !== "") ||
                (this.currentVariation.item.manufacturer.responsibleTown !== "") ||
                (this.currentVariation.item.manufacturer.responsibleContactUrl !== "") ||
                (this.currentVariation.item.manufacturer.responsibleCountry !== 0);
        },

        isRecommendedPriceActive() {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive() {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId() {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive() {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties() {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties() {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },
        pluginPathTheme() {
            return App.pluginPathTheme;
        },
        showPriceAfterLogin() {
            return this.itemData.documents[0].data.properties.find(property => property.property.id === 49);
        },
        isLoggedIn() {
            return App.loggedIn;
        },
        isB2B() {
            return App.isB2B;
        },
        categoryIds() {
            let catIds = _map(this.currentVariation.defaultCategories, "id");
            return catIds.concat(_map(this.currentVariation.defaultCategories, "parentCategoryId"));
        },

        isItemSet() {
            return this.$store.state.items.isItemSet;
        }
    },

    created() {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted() {
        this.$nextTick(() => {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId: this.itemId,
                attributes: this.attributesData,
                variations: this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey: this.afterKey
            });

            if (this.isItemSet) {
                this.$store.dispatch("initSetComponents", this.itemData);
            }
        })

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },

    methods:
    {
        getDataField(field) {
            return get(this.currentVariation, field);
        },

        // multi select properties carry an array of selections, all other casts a single object
        propertyValues(property) {
            if (isNullOrUndefined(property) || isNullOrUndefined(property.values)) {
                return [];
            }

            const values = Array.isArray(property.values) ? property.values : [property.values];

            return values
                .map(value => {
                    if (isNullOrUndefined(value)) {
                        return null;
                    }

                    return isNullOrUndefined(value.value) ? value : value.value;
                })
                .filter(value => !isNullOrUndefined(value) && value !== "");
        },

        getFilteredDataField(field, filter) {
            if (!isNullOrUndefined(this.$options.filters[filter])) {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes) {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate") {
                    component.hydrate();
                }
                else if (component.$children.length) {
                    this.hydrateChildren(component.$children);
                }
            })
        },
        createLoginModal() {
            this.loadComponent("login-modal");

        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
